import { useEffect } from 'react';

import Clarity from '@microsoft/clarity';

import { UserData } from '@/types';

export const useClarityTracking = (currentUserData: UserData | null) => {
  useEffect(() => {
    Clarity.init(window.MS_CLARITY_ID);
    Clarity.identify('sentoa');
    Clarity.consent();
  }, []);

  useEffect(() => {
    Clarity.setTag('user-id', (currentUserData?.id ?? '').toString());
    Clarity.setTag('user-role', (currentUserData?.role.name ?? '').toString());
    Clarity.setTag('org-id', (currentUserData?.organizations[0]?.id ?? '').toString());
  }, [currentUserData]);
};
